import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Api } from '../../api'
import type { Feature } from '../feature'

/** Uploads a document. */
export const executeUpload = store.effects.create(
  (feature: Feature, api: Api) =>
    feature.actions.upload.request.observe().pipe(
      rxjs.exhaustMap(action =>
        api.upload(action.data.input, action.data.file).pipe(
          rxjs.map(() =>
            feature.actions.upload.success.from(action).create({
              request: action.data,
              response: undefined,
            }),
          ),
          rxjs.catchError((error: Error) =>
            rxjs.of(
              feature.actions.upload.error.from(action).create({
                error,
                request: action.data,
              }),
            ),
          ),
        ),
      ),
    ),
)
